import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { FileAttachableType } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';

import { PseudoLink } from '~components/Helpers/PseudoLink';
import { FileAttachment } from '~hooks/useFileAttachment/models';
import { useFileAttachment } from '~hooks/useFileAttachment/useFileAttachment';

const FileAttachmentsReadOnly = ({
  label,
  fileAttachableId,
  fileAttachableType,
}: {
  label?: string;
  fileAttachableId: string;
  fileAttachableType: FileAttachableType;
}) => {
  const { getAllFileAttachmentsById } = useFileAttachment();
  const [attachments, setAttachments] = useState<FileAttachment[]>([]);

  useEffect(() => {
    if (!fileAttachableType || !fileAttachableId) return;

    getAllFileAttachmentsById(fileAttachableId, fileAttachableType).then((attachments) =>
      setAttachments(attachments),
    );
  }, [fileAttachableId, fileAttachableType]);
  return (
    <Box
      sx={{
        mt: 2,
      }}
    >
      <Typography variant="group-title">
        {label ?? t('form_fields.attachments')}
      </Typography>
      {attachments.length
        ? attachments.map((attachment) => (
            <Box
              key={attachment.id}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <Box>
                <PseudoLink
                  title={attachment.fileName}
                  action={() => window.open(attachment.fileUrl)}
                />
                <Typography variant="caption">{attachment.description}</Typography>
              </Box>
              <Chip label={attachment.category} size="small" color="default" />
            </Box>
          ))
        : t('file_attachments.no_attachments')}
    </Box>
  );
};

export default FileAttachmentsReadOnly;
